import { useMutation } from "@tanstack/react-query";
import { createGameNameAssistant } from "../api/createGameNameAssistant";

export const useCreateGameNameAssistantMutation = () => {
  return useMutation({
    mutationFn: createGameNameAssistant,
  });
};
